function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 7.1C63.5 7.1 0 49 0 141.7s63.5 134.6 141.7 134.6 141.7-41.9 141.7-134.6S220 7.1 141.7 7.1zm80 214.2c-19 16.4-46.7 26.7-80 26.7s-61-10.3-80-26.7c-20.6-17.8-33.3-44.5-33.3-79.6S41 79.9 61.7 62.1c19.1-16.4 46.8-26.7 80-26.7 33.3 0 61 10.3 80 26.7 20.6 17.8 33.4 44.5 33.4 79.6s-12.6 61.9-33.4 79.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181 82.3l-39.6 39.6-39.6-39.6-20 20 39.6 39.6-39.6 39.6 20 20.1 39.6-39.6 39.7 39.6 20.1-20.1-39.6-39.6 39.6-39.6z"
})));